import { render, staticRenderFns } from "./TheTranscriptionBox.vue?vue&type=template&id=4208702a&scoped=true"
import script from "./TheTranscriptionBox.vue?vue&type=script&lang=js"
export * from "./TheTranscriptionBox.vue?vue&type=script&lang=js"
import style0 from "./TheTranscriptionBox.vue?vue&type=style&index=0&id=4208702a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4208702a",
  null
  
)

export default component.exports